export function pad2(n) {
  return String(n).padStart(2, "0");
}

export function todayIso() {
  const d = new Date();
  return toIsoDate(d.getFullYear(), d.getMonth() + 1, d.getDate());
}

export function toIsoDate(year, month, day) {
  return `${year}-${pad2(month)}-${pad2(day)}`;
}

export function partsFromIso(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
  const [year, month, day] = iso.split("-").map(Number);
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return null;
  return { year, month, day };
}

export function shiftIsoDate(iso, deltaDays) {
  const parts = partsFromIso(iso);
  if (!parts) return todayIso();
  const d = new Date(parts.year, parts.month - 1, parts.day);
  d.setDate(d.getDate() + deltaDays);
  return toIsoDate(d.getFullYear(), d.getMonth() + 1, d.getDate());
}

export function formatDateLabel(iso) {
  const parts = partsFromIso(iso);
  if (!parts) return iso ?? "";
  const d = new Date(parts.year, parts.month - 1, parts.day);
  return d.toLocaleDateString(undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function isTodayIso(iso, ref = new Date()) {
  const parts = partsFromIso(iso);
  if (!parts) return false;
  return (
    parts.year === ref.getFullYear() &&
    parts.month === ref.getMonth() + 1 &&
    parts.day === ref.getDate()
  );
}

export function todayParts() {
  const ref = new Date();
  return { year: ref.getFullYear(), month: ref.getMonth() + 1, day: ref.getDate() };
}

export function currentMonthParts() {
  const { year, month } = todayParts();
  return { year, month };
}

export function shiftMonth(year, month, deltaMonths) {
  const d = new Date(year, month - 1 + deltaMonths, 1);
  return { year: d.getFullYear(), month: d.getMonth() + 1 };
}

export function formatMonthLabel(year, month) {
  const d = new Date(year, month - 1, 1);
  return d.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}

export function isCurrentMonth(year, month, ref = new Date()) {
  return year === ref.getFullYear() && month === ref.getMonth() + 1;
}

export function toMonthInputValue(year, month) {
  return `${year}-${pad2(month)}`;
}
